import * as actionTypes from 'actions';

const initialState = {
    Loading: false,
    workspaceFormList: [],
  
    WorkspaceFormRecord:[],
    validation_error: "",
    redirect_to_list: false,
    showDeleteModel: false,
    showUpdateForm: false,
    showViewPage: false,
}

const WorkspaceFormReducer = (state = initialState, action) => {
    switch (action.type) {
       
    case actionTypes.WORKSPACE_FORM_REQUEST:
        return {
          ...state,
          Loading: true,
          validation_error: "",
          redirect_to_list: false,
        }
    case actionTypes.WORKSPACE_FORM_SERVER_SUCCESS:
        return {
          ...state, 
          Loading: false,
          redirect_to_list: false,
          validation_error: "",
          showUpdateForm: false,
          showViewPage: false,
          WorkspaceFormRecord: [],
        }    
    case actionTypes.WORKSPACE_FORM_SUCCESS:
        return {
          ...state, 
          Loading: false,
          redirect_to_list: false,
          validation_error: "",
          workspaceFormList: action.workspaceFormList,
          showUpdateForm: false,
          showViewPage: false,
          WorkspaceFormRecord: [],
        }
    
    case actionTypes.WORKSPACE_FORM_GET_SUCCESS:
        return {
            ...state, 
            Loading: false,
            redirect_to_list: false,
            WorkspaceFormRecord: action.record,
            showUpdateForm: (action.actionType === 'update')? true:false,
            showViewPage: (action.actionType === 'view')? true:false
        }    
    case actionTypes.WORKSPACE_FORM_VALIDATION_ERROR:
        return {
            ...state,
            Loading: false,
            redirect_to_list: false,
            validation_error: action.validation_error,
        } 
    case actionTypes.HIDE_WORKSPACE_FORM_FIELD_VALIDATION_ERROR:
        if(state.validation_error && state.validation_error[action.feild_key])
            delete state.validation_error[action.feild_key]
        return {
            ...state,
            Loading: false,
            redirect_to_list: false,
            validation_error: action.validation_error,
            
        } 
    case actionTypes.REDIRECT_TO_WORKSPACE_FORM_LIST:
        return {
            ...state,
            redirect_to_list: true,
            showUpdateForm: false,
            showViewPage: false,
            validation_error: '',
            WorkspaceFormRecord: [],
        }
    default:
        return state;
    }
}

export default WorkspaceFormReducer;